import { NavLink } from "react-router-dom";
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import LanguageSelector from "./LanguageSelector";

const Header = () => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="bg-transparent z-20 relative">
      <div className="max-w-full mx-auto px-8 xl:px-24 py-8 md:py-12 flex justify-between items-center">
        <div className="brand">
          <NavLink to="/">
            NOT ORDINARY <span className="font-bold">BARBERS</span>
          </NavLink>
          <div className="hidden md:flex">
            <LanguageSelector />
          </div>
        </div>
        <nav className="hidden md:flex space-x-8 font-semibold">
          <NavLink
            to="/"
            className={({ isActive }) =>
              (isActive ? "underline underline-offset-8 " : "") + "hover:text-gray-300"
            }
          >
            {t("header.menu.home")}
          </NavLink>
          <NavLink
            to="/chi-siamo"
            className={({ isActive }) =>
              (isActive ? "underline underline-offset-8 " : "") + "hover:text-gray-300"
            }
          >
            {t("header.menu.about")}
          </NavLink>
          <NavLink
            to="/prezzi"
            className={({ isActive }) =>
              (isActive ? "underline underline-offset-8 " : "") + "hover:text-gray-300"
            }
          >
            {t("header.menu.pricing")}
          </NavLink>
          <NavLink
            to="/orari"
            className={({ isActive }) =>
              (isActive ? "underline underline-offset-8 " : "") + "hover:text-gray-300"
            }
          >
            {t("header.menu.schedule")}
          </NavLink>
        </nav>
        <div className="md:hidden flex align-center">
          <button onClick={toggleMenu} className="text-white" aria-label="menu">
            {isOpen ? <XIcon className="h-6 w-6" /> : <MenuIcon className="h-6 w-6" />}
          </button>
        </div>
      </div>
      <div
        className={`fixed top-0 left-0 w-full h-full bg-black bg-opacity-30 backdrop-blur-lg z-30 transform transition-transform ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <button onClick={toggleMenu} className="absolute top-4 right-4" aria-label="menu">
          <XIcon className="h-8 w-8" />
        </button>

        <nav className="flex flex-col items-center justify-center h-full space-y-8 text-2xl font-semibold">
          <NavLink
            to="/"
            onClick={toggleMenu}
            className={({ isActive }) =>
              (isActive ? "underline underline-offset-8 " : "") + "hover:text-gray-300"
            }
          >
            {t("header.menu.home")}
          </NavLink>
          <NavLink
            to="/chi-siamo"
            onClick={toggleMenu}
            className={({ isActive }) =>
              (isActive ? "underline underline-offset-8 " : "") + "hover:text-gray-300"
            }
          >
            {t("header.menu.about")}
          </NavLink>
          <NavLink
            to="/prezzi"
            onClick={toggleMenu}
            className={({ isActive }) =>
              (isActive ? "underline underline-offset-8 " : "") + "hover:text-gray-300"
            }
          >
            {t("header.menu.pricing")}
          </NavLink>
          <NavLink
            to="/orari"
            onClick={toggleMenu}
            className={({ isActive }) =>
              (isActive ? "underline underline-offset-8 " : "") + "hover:text-gray-300"
            }
          >
            {t("header.menu.schedule")}
          </NavLink>
          <div className="absolute bottom-10 left-1/2 -translate-x-1/2 md:hidden">
            <LanguageSelector isMobile />
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
